// Style
import 'bootstrap/dist/css/bootstrap.css';
import 'vue-select/dist/vue-select.css';
import 'vue-datepicker-next/index.css';
import 'vue-slider-component/theme/default.css';
import '@yaireo/tagify/src/tagify.scss';
import './assets/scss/style.scss';

// Javascript
import { createApp } from 'vue';
import axios from 'axios';

// -------- Vendor
import VueProgressBar from '@/plugins/progress-bar';
import clipboardPlugin from '@/plugins/clipboard';
import { Popover } from '@/components/commons';
import popoverPlugin from '@/plugins/popover-manager';
import AppModal from '@/components/AppModal.vue';
import modalPlugin from '@/plugins/modal-manager';
import routerKeys from '@/store/router-keys';
import App from './App.vue';
import router from './router';
import store from './store';
import { Amplify } from 'aws-amplify';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more.src';
import solidGauge from 'highcharts/modules/solid-gauge';

const app = createApp(App);

// Config
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
          scopes: import.meta.env.VITE_COGNITO_OAUTH_SCOPES.split(/\s*,\s*/),
          redirectSignIn: import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN.split(/\s*,\s*/),
          redirectSignOut: import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_OUT.split(/\s*,\s*/),
          responseType: import.meta.env.VITE_COGNITO_OAUTH_RESPONSE_TYPE
        }
      }
    }
  }
});

highchartsMore(Highcharts);
solidGauge(Highcharts);
app.config.globalProperties.$Highcharts = Highcharts;
app.config.globalProperties.axios = axios;
app.config.globalProperties.$http = axios;
app.use(VueProgressBar, {
  color: '#E61C0A',
  failedColor: 'red',
  height: '2px'
});

app.use(modalPlugin);
app.use(popoverPlugin);
app.use(clipboardPlugin);
app.component('modal', AppModal);
app.component('popover', Popover);
app.config.globalProperties.$routerKeys = routerKeys;
app.use(store);
app.use(router);
app.mount('#app');
